module.exports = "https://static.wmbcdn.com/uniweb/images/ea6b5886f31c5833a461205a3c72dc6f.svg";